import type { StripeService } from '../stripeService';
import type { ICustomerSession, SessionFlow } from '../../../entities';
import { InternalStripeRepository } from '../../../network/repositories/internalStripeRepository';

export default class StripeServiceImpl implements StripeService {
  internalStripeRepository: InternalStripeRepository;

  constructor(internalStripeRepository: InternalStripeRepository) {
    this.internalStripeRepository = internalStripeRepository;
  }

  createSession(data: {
    returnUrl: string;
    flowType?: SessionFlow;
    successUrl?: string;
    songId?: string;
    releaseId?: string;
    isDistributionUpsellFlow?: boolean;
  }): Promise<ICustomerSession> {
    const { internalStripeRepository } = this;
    return internalStripeRepository.createSession(data);
  }

  createCheckoutSession(
    priceId: string,
    successURL: string,
    cancelURL: string,
    referral?: string
  ): Promise<{ checkoutURL: string }> {
    const { internalStripeRepository } = this;

    return internalStripeRepository.createCheckoutSession(
      priceId,
      successURL,
      cancelURL,
      referral
    );
  }
}
